import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section id="hero" className="relative min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20curated%20flat%20lay%20of%20premium%20streetwear%20fashion%20items%20including%20sneakers%20a%20hoodie%20a%20cap%20sunglasses%20and%20a%20small%20backpack%20arranged%20with%20generous%20spacing%20on%20a%20soft%20sage%20green%20background%2C%20bright%20airy%20daylight%2C%20clean%20modern%20ecommerce%20editorial%20photography%2C%20fresh%20minimal%20aesthetic%20with%20soft%20shadows&width=1600&height=900&seq=hero-bg-1&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet Products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6">
            {t('hero_title')}
          </h1>
          <p className="text-base md:text-lg text-white/90 leading-relaxed mb-6 md:mb-8 max-w-2xl mx-auto">
            {t('hero_subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors text-sm md:text-base whitespace-nowrap"
            >
              {t('hero_cta_primary')}
            </a>
            <a
              href="/cssbuy-spreadsheet/"
              className="px-6 py-3 bg-white/10 backdrop-blur-sm text-white font-medium rounded-lg hover:bg-white/20 transition-colors border border-white/30 text-sm md:text-base whitespace-nowrap"
            >
              {t('hero_cta_secondary')}
            </a>
          </div>
          <p className="mt-4 text-xs md:text-sm text-white/70 tracking-wide">
            {t('hero_trust')}
          </p>
        </div>
      </div>
    </section>
  );
}